import {useAuth0} from "@auth0/auth0-react";
import React from "react";
import {Box, Button} from "@material-ui/core";
import LoginAsUtils from "../../state/utils/LoginAsUtils";

/**
 * ログアウトボタンの機能
 *
 * @param {string} signOutUri - ログアウト用URL
 * @param {*} t - 翻訳対象
 * @param isPretendMode
 * @param {*} rest -  追加属性
 * @returns {JSX.Element}
 * @constructor
 */
const LogOutButton = ({signOutUri, t, isPretendMode, ...rest}) => {
    const {logout} = useAuth0();
    return (
        <Box p={1} onClick={() => {
            if (!isPretendMode) {
                logout({returnTo: window.location.origin + signOutUri})
            } else {
                LoginAsUtils.remove();
                window.close();
            }
        }}>
            <Button variant="contained" color={"secondary"} {...rest} >
                {t('actions.logout')}
            </Button>
        </Box>
    )
}

export default LogOutButton;
